import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { CoreUiModule } from '../core-ui/core-ui.module';
import { ReceiptFacade } from './+state';
import { PurchaseInvoiceComponent } from './components/purchase-invoice/purchase-invoice.component';
import { ReceiptService } from './receipt.service';


@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        CoreUiModule,
        ReactiveFormsModule
    ],
    declarations: [ PurchaseInvoiceComponent ],
    exports: [ PurchaseInvoiceComponent ],
    providers: [ ReceiptService, ReceiptFacade ]
} )
export class ReceiptModule { }
